module.exports = __webpack_public_path__ + "static/media/puzzle.d81d8fe2.svg";